export const ROLES = {
  USER: 'user',
  MANAGER: 'manager',
  ADMIN: 'admin',
};

// Assignable roles with their display labels (used by the admin roles panel).
// Legacy 'owner' docs are treated as 'manager' throughout the app.
export const ASSIGNABLE_ROLES = [ROLES.USER, ROLES.MANAGER, ROLES.ADMIN];

export const SPORTS = {
  FUTBOL: 'Futbol',
  PADEL: 'Padel',
};

export const TEAM = {
  LOCAL: 0,
  VISIT: 1,
};
export const SPORTS_ICONS = {
  FUTBOL: '⚽',
  PADEL: '🥎',
};

export const STATE = {
  OLD: 'old',
  IN: 'in',
  NEW: 'new',
};

export const VIEW = {
  LIST: 'list',
  GRID: 'grid',
  CALENDAR: 'calendar',
  MAP: 'map',
};

export const LEVELS = {
  BASIC: 'Basico',
  MEDIUM: 'Medio',
  ADVANCE: 'Avanzado',
};

export const POSITION = {
  ANY: 'Todas',
  GOALKEEPER: 'Portero',
  DEFENCE: 'Defensa',
  MIDFIELD: 'Mediocampo',
  FOWARD: 'Delantero',
};
export const LANGUAGES = {
  SPANISH: 'es',
  ENGLISH: 'en',
  ARABIC: 'ar',
};
